// Analítica de la plantilla V2. Eventos sin información personal: nunca se
// registran nombres, correos, teléfonos ni datos de pago.
//
// Los eventos se publican en `window.dataLayer` (si existe) y se registran en
// consola solamente durante el desarrollo.
export type TourV2Event =
  | "tour_viewed"
  | "availability_opened"
  | "date_selected"
  | "participants_changed"
  | "booking_started"
  | "booking_abandoned"
  | "recent_tour_shown"
  | "recent_tour_reopened"
  | "recent_tour_dismissed"
  | "related_tour_clicked"
  | "booking_completed";

/** Claves permitidas: nunca datos personales. */
export interface TourV2EventProps {
  tourSlug?: string;
  tourId?: string;
  destination?: string | null;
  currency?: string;
  amount?: number;
  pax?: number;
  date?: string | null;
  startTime?: string | null;
  categories?: number;
}

const BANNED = /name|mail|phone|tel|card|address|apellid|nombre|correo|telefono/i;

export function trackTourV2(event: TourV2Event, props: TourV2EventProps = {}): void {
  if (typeof window === "undefined") return;
  const safe: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(props)) {
    if (BANNED.test(k) || v == null) continue;
    safe[k] = v;
  }
  try {
    const dl = (window as unknown as { dataLayer?: unknown[] }).dataLayer;
    if (Array.isArray(dl)) dl.push({ event, ...safe });
  } catch {
    /* noop */
  }
  if (import.meta.env.DEV) console.debug("[tourV2:analytics]", event, safe);
}
